// src/elements/Table/Table.Tbody.tsx
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var Tbody = _ref => {
  let {
    children,
    className
  } = _ref;
  return /* @__PURE__ */jsx("tbody", {
    className: clsx("pd:table__tbody", className),
    children
  });
};
var Table_Tbody_default = Tbody;
export { Table_Tbody_default };